import React from 'react'
import NumberFormat from 'react-number-format';
import Controls from './Controls';

export default function InputCurrency(props) {

    const { name, label, max, value, error=null, helperText=error, onChange, ...other } = props;
    const MAX_VAL = max ? max : 99999999.99;
    const withValueLimit = ({ floatValue }) => floatValue <= MAX_VAL;
    return (
        <NumberFormat
            label={label}
            prefix="R$ "
            thousandSeparator="."
            decimalSeparator=","
            decimalScale={2}
            fixedDecimalScale="true"
            value={value}
            onValueChange={onChange}
            customInput={Controls.Input}
            isAllowed={withValueLimit}
            {...other}
            {...(error && {error:true,helperText:error})}
            helperText={helperText}
        />
    );
}
